/* base-image-fade: mark lazy images as loaded so they fade in (see base-tokens).
   Images inside the cart drawer (and quick-add) are made eager and shown at once: they are
   rendered off-screen and only become visible when the drawer opens, which left them blank. */
(function () {
  function mark(img) {
    if (img.closest('cart-drawer, .cart-drawer, quick-add-modal, .quick-add-modal')) {
      img.loading = 'eager';
      img.classList.add('is-loaded');
      return;
    }
    if (img.complete && img.naturalWidth > 0) { img.classList.add('is-loaded'); return; }
    img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
  }
  function scan(root) { (root.querySelectorAll ? root.querySelectorAll('img[loading="lazy"]') : []).forEach(mark); }
  scan(document);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches && n.matches('img[loading="lazy"]')) mark(n); scan(n); } }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
